/**
 * ArchiveSidebar — vertical collapsible nav rail
 *
 * Markup contract:
 *   [data-site-header]   → <header> root
 *   [data-menu-toggle]   → any element that toggles open/close
 *                          (hamburger button + overlay scrim both carry this)
 *   [data-nav-panel]     → <nav> expanded panel
 *   [data-menu-overlay]  → scrim overlay (also carries [data-menu-toggle])
 */
class ArchiveSidebar {
  constructor() {
    this.header = document.querySelector('[data-site-header]');
    this.navPanel = document.querySelector('[data-nav-panel]');
    this.overlay = document.querySelector('[data-menu-overlay]');
    // Primary toggle button (hamburger) — not the overlay scrim
    this.toggleBtn = this.header?.querySelector('.site-rail__toggle');

    if (!this.header) return;

    document.addEventListener('click', this.handleClick.bind(this));
    document.addEventListener('keydown', this.handleKeydown.bind(this));
    document.addEventListener('archive:menu-close', () => {
      if (this.isOpen()) this.close();
    });
    document.documentElement.classList.remove('no-js');
  }

  handleClick(event) {
    // Accordion toggles inside the panel ("creators"/"instruments" trees)
    const accordion = event.target.closest('[data-nav-accordion]');
    if (accordion) {
      event.preventDefault();
      const controlsId = accordion.getAttribute('aria-controls');
      const target = document.getElementById(controlsId);
      const isExpanded = accordion.getAttribute('aria-expanded') === 'true';
      // The cart row has two controls (label + toggle) for one target — keep
      // every control pointing at this target in sync.
      document.querySelectorAll(`[data-nav-accordion][aria-controls="${controlsId}"]`).forEach((control) => {
        control.setAttribute('aria-expanded', String(!isExpanded));
        control.classList.toggle('is-open', !isExpanded);
      });
      if (target) target.hidden = isExpanded;
      return;
    }

    if (event.target.closest('[data-menu-toggle]')) {
      event.preventDefault();
      this.isOpen() ? this.close() : this.open();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isOpen()) {
      this.close();
    }
  }

  isOpen() {
    return this.navPanel?.classList.contains('is-open');
  }

  open() {
    this.navPanel?.classList.add('is-open');
    this.navPanel?.setAttribute('aria-hidden', 'false');
    this.overlay?.classList.add('is-open');
    this.header.classList.add('menu-open');
    this.toggleBtn?.setAttribute('aria-expanded', 'true');
    this.toggleBtn?.setAttribute('aria-label', 'Close navigation');
    document.body.classList.add('menu-open');
  }

  close() {
    this.navPanel?.classList.remove('is-open');
    this.navPanel?.setAttribute('aria-hidden', 'true');
    this.overlay?.classList.remove('is-open');
    this.header.classList.remove('menu-open');
    this.toggleBtn?.setAttribute('aria-expanded', 'false');
    this.toggleBtn?.setAttribute('aria-label', 'Open navigation');
    document.body.classList.remove('menu-open');

    // Return focus to the toggle button
    this.toggleBtn?.focus();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ArchiveSidebar();
});
